export default "__VITE_ASSET__CdLyJO7u__"